<script lang="ts" setup>


const aiServices = [
  {
    title: "Machine Learning",
    description: "Drive smarter outcomes<br>tailored to your unique needs.",
    svg: "WrMachineLearning",
  },
  {
    title: "Text & Natural Language Processing",
    description:
      "Transform text data into actionable<br>insights with our NLP expertise.",
    svg: "WrWrapText",
  },
  {
    title: "Audio & Speech-to-Text",
    description: "Convert spoken language into<br>text effortlessly.",
    svg: "WrSpeechToText",
  },
  {
    title: "Images, Video & Computer Vision",
    description: "Process and interpret visual<br>media with AI.",
    svg: "WrVideo",
  },
  {
    title: "Assisted Video Object Tracking",
    description: "Streamline video object<br>identification.",
    svg: "WrAssistedVideo",
  },
];
</script>

<template>
  <div class="max-w-[350px] md:max-w-[950px] mx-auto relative z-10">
    <h3
      class="text-xl md:text-2xl text-center mb-8 md:mb-12 text-[var(--secondary-foreground)]"
    >
      Our AI-Powered services
    </h3>

    <div
      class="text-[var(--secondary-foreground)] w-full flex flex-wrap md:justify-center relative before:content-[''] max-md:before:top-0 max-md:before:left-0 max-md:before:w-px max-md:before:h-full before:absolute before:left-0 before:top-1/2 before:-translate-y-[1px] before:w-full before:h-px max-md:before:bg-[linear-gradient(180deg,var(--color-7)_-10%,#ffffff00_100%)] before:bg-[linear-gradient(90deg,#62457400_0%,#9169AA_52.5%,#62457400_100%)]"
    >
      <div
        v-for="service in aiServices"
        :key="service.title"
        class="px-4 md:px-2 lg:px-4 py-7 relative w-full max-w-max after:content-[''] after:absolute after:w-full after:h-full after:top-0 after:left-0 after:opacity-0 hover:after:opacity-100 [&:nth-last-child(-n+2)]:after:bg-[linear-gradient(to_top,rgba(255,255,255,0)_0%,rgba(255,255,255,0.06)_100%)] after:bg-[linear-gradient(to_bottom,rgba(255,255,255,0)_0%,rgba(255,255,255,0.06)_100%)] after:transition-opacity after:duration-[450ms] after:ease-[cubic-bezier(0.6,0.6,0,1)] md:text-center max-md:before:content-none last:before:content-none before:[&:nth-child(3)]:content-none before:content-[''] before:[&:nth-child(4)]:bg-[linear-gradient(to_top,rgba(98,69,116,0)_0%,#9169AA_100%)] before:bg-[linear-gradient(to_bottom,rgba(98,69,116,0)_0%,#9169AA_100%)] before:absolute before:right-0 before:top-0 before:w-px before:h-full"
      >
        <div class="text-4xl mb-2">
          <!-- <component :is="service.svg" class="sm:mx-auto" /> -->
          <WrSVGIcon :name="service.svg" class="size-[36px]" />
        </div>
        <h3
          class="text-xl font-semibold mb-2 lg:whitespace-nowrap relative max-md:after:content-[''] max-md:after:absolute max-md:after:top-1 max-md:after:-left-4 max-md:after:w-px max-md:after:h-5 max-md:after:bg-[var(--primary)]"
        >
          {{ service.title }}
        </h3>
        <p
          class="dark:text-[#AF66E4] text-sm max-w-xs tracking-[0.5px]"
          v-html="service.description"
        ></p>
      </div>
    </div>
  </div>
</template>
